"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.componentPropertiesCsvTableRowSchema = exports.CSV_COLUMN_NAMES = void 0;
const z = require("zod");
exports.CSV_COLUMN_NAMES = {
    SIGNAL_NAME: 'Signal Name',
    PINS: 'Pins',
    ATTRIBUTES: 'Attributes',
    IS_GLOBAL_POWER: 'Is Global Power',
    IS_GLOBAL_GROUND: 'Is Global Ground',
    POWER_RAIL_OVERRIDE: 'Power Rail Override',
    GROUND_RAIL_OVERRIDE: 'Ground Rail Override',
    ABSOLUTE_MAXIMUM_RATINGS: 'Absolute Maximum Ratings (V)',
    OPERATING_CONDITIONS: 'Operating Conditions (V)',
    FUNCTIONS: 'Functions (Bus Classes)',
    SIGNAL_DRIVE_CHARACTERISTICS: 'Signal Drive Characteristics',
};
exports.componentPropertiesCsvTableRowSchema = z.object({
    [exports.CSV_COLUMN_NAMES.SIGNAL_NAME]: z.string(),
    [exports.CSV_COLUMN_NAMES.PINS]: z.string(),
    [exports.CSV_COLUMN_NAMES.ATTRIBUTES]: z.string(),
    [exports.CSV_COLUMN_NAMES.IS_GLOBAL_POWER]: z.string(),
    [exports.CSV_COLUMN_NAMES.IS_GLOBAL_GROUND]: z.string(),
    [exports.CSV_COLUMN_NAMES.POWER_RAIL_OVERRIDE]: z.string(),
    [exports.CSV_COLUMN_NAMES.GROUND_RAIL_OVERRIDE]: z.string(),
    [exports.CSV_COLUMN_NAMES.ABSOLUTE_MAXIMUM_RATINGS]: z.string(),
    [exports.CSV_COLUMN_NAMES.OPERATING_CONDITIONS]: z.string(),
    [exports.CSV_COLUMN_NAMES.FUNCTIONS]: z.string(),
    [exports.CSV_COLUMN_NAMES.SIGNAL_DRIVE_CHARACTERISTICS]: z.string(),
});
//# sourceMappingURL=csv-row.js.map